module.exports = __webpack_public_path__ + "img/grey_038.c9c3f6bc.png";